<template>
  <listing-layout>
    <div slot="content" :class="{ 'acting-readonly': $isActingForOtherCommittee }">
      <div v-if="isDeleted && !isLoading">
        <h1 class="h2 mb-3">Committee Affiliation Application</h1>
        <div>
          Error. Please contact the ACA office for further clarifications.
        </div>
      </div>
      <div v-else>
        <div v-if="allowCommittee === true">
          <committee-affiliation-form
            :secretary="memberDetails"
            :committeeDetails="committee"
            :isLoading="isLoading"
          />
        </div>
      </div>
      <div class="text-center p-2" v-if="!allowCommittee">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </listing-layout>
</template>

<script>
import axios from "axios"
import listingLayout from '@/components/ListingLayout'
import GETSTORE from '@/store/memberProfileStore'
import CommitteeAffiliationForm from "./components/CommitteeAffiliationForm"

export default {
  name: 'CommitteeAffiliation',
  mixins: [GETSTORE],
  components: {
    listingLayout,
    CommitteeAffiliationForm
  },
  data() {
    return {
      userID: localStorage.userID,
      userRole: localStorage.role,
      committee: null,
      isLoading: true,
      allowCommittee: true,
      isDeleted: false
    }
  },
  watch: {
    memberDetails() {
      if (!this.memberDetails.committee_id) {
        this.$router.push('/committees/not-registered')
      }
      this.allowCommittee = true
      axios.get(`${this.$api}/admin/committee-details/${this.memberDetails.committee_id}`)
        .then((response) => {
          this.isLoading = false
          if (response?.data?.status === 'success') {
            this.committee = response.data.data
            if (
              this.committee.is_financial ||
              (
                this.committee.current_affiliation &&
                this.committee.current_affiliation.is_invoice_created === 1
              )
            ) {
              this.$router.push('/committees/edit')
            }
          } else if (response?.data?.status === 'committee_is_deleted') {
            this.isDeleted = true
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Committees/Affiliation/CommitteeAffiliation.vue